export const GET_NEW_SUGGESTIONS = 'GET_NEW_SUGGESTIONS';
export const SAVE_COUNTER_SUGGESTIONS = 'SAVE_COUNTER_SUGGESTIONS';
export const SHOW_SUGGESTIONS = 'SHOW_SUGGESTIONS';
export const TOGGLE_SUGGESTIONS = 'TOGGLE_SUGGESTIONS';
export const HIDE_SUGGESTIONS = 'HIDE_SUGGESTIONS';
export const NEW_SUGGESTIONS = 'NEW_SUGGESTIONS';
